import { render, staticRenderFns } from "./ActivityTabSidebar.vue?vue&type=template&id=fa6ab3e0&scoped=true&"
import script from "./ActivityTabSidebar.vue?vue&type=script&lang=js&"
export * from "./ActivityTabSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTabSidebar.vue?vue&type=style&index=0&id=fa6ab3e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6ab3e0",
  null
  
)

export default component.exports